import { Chip } from '@mui/material'
import { styles } from './styles'
import type { CompanyStatusProps } from './types'

export const CompanyStatus = ({ status }: CompanyStatusProps) => {
  switch (status) {
    case 'CONFIRMED':
      return (
        <Chip
          sx={styles.chip}
          variant={'outlined'}
          color="success"
          //label={'Действует'}
          label={'Действующая'}
        />
      )
    case 'DRAFT':
      return (
        <Chip
          sx={{
            ...styles.chip,
            color: '#787878',
            borderColor: '#8E8E8E',
            backgroundColor: '#EEEEEE',
          }}
          variant={'outlined'}
          label={'Черновик'}
        />
      )
    case 'DELETED':
      return (
        <Chip
          sx={styles.chip}
          variant={'outlined'}
          color="warning"
          label={'Заблокирована'}
        />
      )
    case 'ACTIVE':
      return (
        <Chip
          sx={styles.chip}
          variant={'outlined'}
          color="success"
          label={'Действующая'}
        />
      )
    case 'LIQUIDATED':
      return (
        <Chip
          sx={styles.chip}
          variant={'outlined'}
          color="error"
          label={'Ликвидирована'}
        />
      )
    default:
      return (
        <Chip
          sx={styles.chip}
          variant={'outlined'}
          color="primary"
          label={'...'}
        />
      )
  }
}
